import { useRef } from "react";
import { Form } from "react-bootstrap";
import { IoMdInformationCircleOutline } from "react-icons/io";
import Select from "react-select";

const FormCellMultiselect = ({
  props,
  required = false,
  actualName,
  displayName,
  options,
  placeholder,
  datatip,
  bottomText,
  selectionLimit,
}) => {
  const multiselectRef = useRef(null);

  return (
    <div className="ideacheckeritem">
      <Form.Label>
        {required && <sup>*</sup>}
        {displayName}
        {datatip && (
          <sup data-tip={datatip}>
            <IoMdInformationCircleOutline id="information-icon" />
          </sup>
        )}
      </Form.Label>

      <Select
        ref={multiselectRef}
        options={options}
        isMulti={selectionLimit !== 1}
        value={
          selectionLimit === 1
            ? options.find(
                (option) => option.key === props.state[actualName],
              ) || null
            : options.filter((option) =>
                props.state[actualName]?.includes(option.key),
              )
        }
        getOptionLabel={(option) => option.key}
        getOptionValue={(option) => option.key}
        isOptionDisabled={() =>
          selectionLimit !== 1 &&
          props.state[actualName]?.length >= selectionLimit
        }
        placeholder={placeholder}
        closeMenuOnSelect={selectionLimit === 1}
        hideSelectedOptions={false}
        onChange={(selectedItems) => {
          if (selectionLimit === 1) {
            const list = selectedItems?.key || "";

            props.setState({
              type: "update value to state property",
              stateName: actualName,
              value: list,
            });
          } else {
            const list = selectedItems?.map((item) => item.key) || [];

            props.setState({
              type: "update value to state property",
              stateName: actualName,
              value: list,
            });
          }
        }}
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "35px",

            border: "1px solid #ced4da",
            fontFamily: "AileronRegular",
            fontSize: "14px",
            color: "#495057",
          }),
          option: (base) => ({
            ...base,
            fontFamily: "AileronRegular",
            fontSize: "14px",
            color: "#495057",
          }),
        }}
      />

      <Form.Text className="text-muted">{bottomText}</Form.Text>
    </div>
  );
};

export default FormCellMultiselect;
